import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/page-client.tsx");
